"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'en': {
        'translation': {
            'Reset all filters': 'Reset all filters'
        }
    },
    'es': {
        'translation': {
            'Reset all filters': 'Restablecer todos los filtros'
        }
    },
    'da': {
        'translation': {
            'Reset all filters': 'Nulstil alle filtre'
        }
    },
    'de': {
        'translation': {
            'Reset all filters': 'Alle Filter löschen'
        }
    },
    'fi': {
        'translation': {
            'Reset all filters': 'Nollaa suodattimet'
        }
    },
    'fr': {
        'translation': {
            'Reset all filters': 'Réinit tous filtres'
        }
    },
    'it': {
        'translation': {
            'Reset all filters': 'Ripristina tutti i filtri'
        }
    },
    'ko': {
        'translation': {
            'Reset all filters': '모든 필터 재설정'
        }
    },
    'nl': {
        'translation': {
            'Reset all filters': 'Reset alle filters'
        }
    },
    'zh': {
        'translation': {
            'Reset all filters': '重設所有過濾條件'
        }
    },
};
//# sourceMappingURL=translations.js.map